module.exports = "/static/Images/en/negative.png";